import { Field, Form, Formik } from 'formik';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AuthenticateChildren from '../../AuthenticateChildren';
import BackButton from '../../components/BackButton';
import { FloatingCheckbox, FloatingPlaceholderCreatableSelect } from '../../components/FloatingPlaceholder';
import { Loader } from '../../components/Loader';
import { NotFound } from '../../components/NotFound';
import { PTInputSelect, PTInputText, PTInputTextArea } from '../../components/PTElements';
import { SubmitButton } from '../../components/SubmitButton';
import { choreTypes, roles, startFrom, taskNames } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/chores";
import { urls } from '../../urls';
import './ChoreDetails.css';

const ChoreDetails = props => {
    useEffect(() => {
        props.fetchchores(props);
    }, []);

    const save = (values, { setSubmitting }) => {
        props.addOrUpdateItem(values)
            .then(() => EVO.success('Success!'))
            .finally(() => {
                setSubmitting(false);
                EVO.updateIdFromNew(props, props.chore, urls.router.chores.index.url);
            });
    }

    return (
        <div className="chd">
            <Loader loading={props.loading && props.chore}>
                <BackButton />
                <NotFound found={props.chore}>
                    <div>
                        <h1>{props.chore && props.chore.name ? props.chore.name : 'Add new'}</h1>
                        <Formik
                            initialValues={props.chore}
                            onSubmit={save}
                            enableReinitialize={true}>
                            {({ isSubmitting, values, setFieldValue }) => (
                                <Form>
                                    <Desc text="Name">
                                        <Field name="name" component={PTInputText} left />
                                    </Desc>
                                    <Desc text="Task Type">
                                        <Field name="taskName" component={PTInputSelect} options={taskNames} left />
                                    </Desc>
                                    <Desc text="What is the Tooltip for the chore">
                                        <Field name="tooltip" component={PTInputTextArea} left />
                                    </Desc>
                                    <Desc text="What is the Chore Type">
                                        <Field name="choreTypeId" component={PTInputSelect} options={choreTypes} left />
                                    </Desc>
                                    <Desc text="Is this a Daily task or executed constantly?">
                                        <Field name="startFrom" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(startFrom)} left />
                                    </Desc>
                                    {values.startFrom === startFrom.StartOfDay.value && 
                                        <div>
                                            <Desc text={`How many minutes before/after midnight this morning?`}>
                                                <Field name="startTimeOffset" type="number" component={PTInputText} onChange={(a) => setFieldValue('', -a)} left />
                                        </Desc>
                                        <Desc text="How many minutes after the value above is the chore valid for?">
                                            <Field name="endTimeOffset" type="number" component={PTInputText} left />
                                        </Desc>
                                        <Desc text="What time does the daily task execute at?">
                                            <Field name="executeAt" type="time" component={PTInputText} left />
                                        </Desc>
                                        {values.startTimeOffset + values.endTimeOffset > 0 && <Field name="alwaysSendPreApp" component={FloatingCheckbox}
                                            placeholder="Send even if appointment booked after the scheduled send time for this pre-appointment email?" />}
                                    </div>}
                                    {values.startFrom === startFrom.Now.value &&
                                        <div>
                                            <Desc text={`How many minutes before/after the appointment`}>
                                                <Field name="startTimeOffsetNeg" type="number" component={PTInputText} onChange={(a) => setFieldValue('startTimeOffset', -a)} left />
                                        </Desc>
                                        <Desc text="What is the validity period for this job (if unsure, default to 7)?">
                                            <Field name="endTimeOffset" type="number" component={PTInputText} left />
                                        </Desc>
                                        </div>}
                                    <Desc text="What are the category limitations? This is a commar separated list of restrictions">
                                        <Field name="categoryQuery" type="text" component={PTInputText} left />
                                    </Desc>
                                    {values.choreTypeId === 1 &&
                                        <Desc text="Is filter AND not OR?">
                                            <Field name="andFilter" component={FloatingCheckbox} left />
                                        </Desc>}
                                    <Desc text="What are the appointment type limitations? This is a commar separated list of restrictions">
                                        <Field name="appointmentTypeQuery" type="text" component={PTInputText} left />
                                    </Desc>
                                    <Desc text="Is there an additional payload for the task?">
                                        <Field name="additionalPayload" component={PTInputTextArea} left />
                                    </Desc>
                                    <Field name="onCreateOnly" component={FloatingCheckbox} placeholder="On Create Only" />
                                    <AuthenticateChildren roles={[roles.Admin]}>
                                        {(!props.chore || !props.chore.id) && values.choreTypeId === 2 &&
                                            <Desc text="Add To All Existing Clients?">
                                                <Field name="addToAllExistingClients" component={FloatingCheckbox} left />
                                            </Desc>}
                                        
                                        {values.startFrom === startFrom.StartOfDay.value &&
                                            <Desc text="What is the threshold of the chore? (in minutes)">
                                                <Field name="alertThreshold" type="number" component={PTInputText} left />
                                            </Desc>}
                                        <Desc text="Are there any tags for this chore?">
                                            <Field name="tags" component={FloatingPlaceholderCreatableSelect}
                                                options={EVO.getSelectItemFromSingularArray(props.allTags)} placeholder="Tags" isMulti />
                                        </Desc>
                                    </AuthenticateChildren>
                                    <SubmitButton type="submit" disabled={isSubmitting} classNames={{ 'loading': isSubmitting }} text='Submit' />
                                </Form>
                            )}
                        </Formik>
                    </div>
                </NotFound>
            </Loader>
        </div>
    );
};

const Desc = ({ text, children }) => <div className="chd-desc">{text}<div>{children}</div></div>;

const mapStateToProps = ({ chores }) => ({
    chore: chores.chore,
    loading: chores.loading,
    error: chores.error,
    allTags: chores.allTags
});

export default connect(mapStateToProps, actions)(withRouter(ChoreDetails));


// WEBPACK FOOTER //
// ./src/pages/Chores/ChoresDetails.js